import { CUTOFF_LUNCH_MENU_LIST } from "../../actionTypes/admin";

const intialState = {
  cutoffLunchMenuList: [],
};

export default function CutoffLunchMenuReducers(state = intialState, action) {
  switch (action.type) {

    case CUTOFF_LUNCH_MENU_LIST:
      return { ...state, cutoffLunchMenuList: action.payload };

    default:
      return state;
  }
}
